module.exports = __webpack_public_path__ + "img/20.26849136.jpg";